<div class="modal-header">
  <h3 class="modal-title">
    {{ 'general.create' | translate }}
  </h3>

  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  >
  </button>
</div>

<div class="modal-body">
  <organization-form
    [organization]="organization"
    (onSubmit)="onSubmit($event)"
  ></organization-form>
</div>
